import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronDown, ChevronUp } from 'lucide-react';
import { services } from '../mock';

const ServiceItem = ({ service, isOpen, onToggle }) => {
  return (
    <div className="service-item">
      <button
        className="service-item-header"
        onClick={onToggle}
        aria-expanded={isOpen}
      >
        <div className="service-item-title-section">
          <h3 className="service-item-title">{service.title}</h3>
          <p className="service-item-short-desc">{service.shortDesc}</p>
        </div>
        <div className="service-toggle-icon">
          {isOpen ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
        </div>
      </button>
      
      {isOpen && (
        <div className="service-item-content">
          <p className="service-item-description">{service.description}</p>
          <div className="service-features">
            <h4 className="service-features-title">Key Features:</h4>
            <ul className="service-features-list">
              {service.features.map((feature, index) => (
                <li key={index} className="service-feature-item">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

const Services = () => {
  const [openService, setOpenService] = useState(null);

  const toggleService = (serviceId) => {
    setOpenService(openService === serviceId ? null : serviceId);
  };

  return (
    <div className="page-container">
      {/* Services Hero */}
      <section className="services-hero">
        <div className="services-hero-content">
          <h1 className="page-title">Our Services</h1>
          <p className="page-subtitle">
            Comprehensive IT infrastructure support, troubleshooting, and installation services 
            tailored to your business needs
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="services-list-section">
        <div className="services-list-content">
          <div className="services-accordion">
            {services.map((service) => (
              <ServiceItem
                key={service.id}
                service={service}
                isOpen={openService === service.id}
                onToggle={() => toggleService(service.id)}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Service Process */}
      <section className="service-process-section">
        <div className="section-header">
          <h2 className="section-title">How We Work</h2>
          <p className="section-description">
            Our streamlined process ensures efficient service delivery
          </p>
        </div>
        <div className="process-grid">
          <div className="process-step">
            <div className="process-number">01</div>
            <h3 className="process-title">Initial Contact</h3>
            <p className="process-description">
              Reach out via phone, email, or our contact form to describe your needs
            </p>
          </div>
          <div className="process-step">
            <div className="process-number">02</div>
            <h3 className="process-title">Assessment</h3>
            <p className="process-description">
              We evaluate your requirements and provide a detailed quote
            </p>
          </div>
          <div className="process-step">
            <div className="process-number">03</div>
            <h3 className="process-title">Deployment</h3>
            <p className="process-description">
              Our engineers arrive on-site ready to complete the work efficiently
            </p>
          </div>
          <div className="process-step">
            <div className="process-number">04</div>
            <h3 className="process-title">Testing & Handoff</h3>
            <p className="process-description">
              Thorough testing and documentation ensure everything works perfectly
            </p>
          </div>
        </div>
      </section>

      {/* Emergency Support Highlight */}
      <section className="emergency-highlight-section">
        <div className="emergency-highlight-content">
          <h2 className="emergency-highlight-title">Need Emergency Support?</h2>
          <p className="emergency-highlight-description">
            For critical P1/P0 incidents, our 24/7 emergency response team is ready to assist
          </p>
          <Link to="/contact" className="btn-primary">
            Contact Emergency Support
            <ArrowRight size={20} />
          </Link>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">Ready to Get Started?</h2>
          <p className="cta-description">
            Request a quote or contact us to discuss your specific requirements
          </p>
          <div className="cta-actions">
            <Link to="/contact" className="btn-primary">
              Get a Quote
              <ArrowRight size={20} />
            </Link>
            <Link to="/about" className="btn-secondary">
              Learn About Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
